export const dec = (x) => Number(x) - 1
